import {
    Grid,
    GridProps,
    Text,
} from '@chakra-ui/react';
import { Image } from 'shared';
import {
    PopularServicesGroupCateringModel,
    PopularServicesGroupCulinaryStudioModel,
    PopularServicesGroupDeliveryModel,
    PopularServicesGroupOutdoorBarModel,
    PopularServicesGroupSweetShopModel,
} from 'entities/popular-services-group';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Link } from 'shared/ui/Link';

export type HomePageMainPopularServicesGroupSectionProps = {
    catering?: PopularServicesGroupCateringModel,
    delivery?: PopularServicesGroupDeliveryModel,
    culinaryStudio?: PopularServicesGroupCulinaryStudioModel,
    outdoorBar?: PopularServicesGroupOutdoorBarModel,
    sweetShop?: PopularServicesGroupSweetShopModel,
} & GridProps & React.RefAttributes<HTMLDivElement>

export const HomePageMainPopularServicesGroupSection
: React.FC<HomePageMainPopularServicesGroupSectionProps> = ({
    catering,
    delivery,
    culinaryStudio,
    outdoorBar,
    sweetShop,
    ...props
}) => (
    <Grid
        {...props}
        templateColumns={{
            base: '1fr',
            lg: '1fr 1fr 1fr',
        }}
        gap="2rem"
    >
        {catering?.formats && (
            <Link to="/catering">
                <Grid
                    gap="1rem"
                    height="fit-content"
                >
                    <Text
                        fontSize="2rem"
                        fontWeight="light"
                    >
                        КЕЙТЕРИНГ
                    </Text>
                    <Grid
                        height="10px"
                        background="#000000"
                    />
                    <Image
                        src={catering?.image?.url}
                        aspectRatio="3 / 2"
                        objectFit="cover"
                    />
                    <Grid
                        templateColumns="auto 1fr"
                        gap="1.25rem"
                    >
                        <Grid
                            width="2px"
                            background="#000000"
                        />
                        <Grid
                            gap="2rem"
                        >
                            {catering.formats?.map(({
                                uid,
                                name,
                                shortDescription,
                            }) => (
                                <Grid
                                    gap="1rem"
                                    height="fit-content"
                                >
                                    <Link to={`/catering/formats/${uid}`}>
                                        <Text
                                            fontSize="1.5rem"
                                            fontWeight="bold"
                                            textDecoration="underline"
                                        >
                                            {name}
                                        </Text>
                                    </Link>
                                    <Text
                                        fontSize="1rem"
                                        textAlign="justify"
                                    >
                                        {shortDescription}
                                    </Text>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Link>
        )}
        {delivery?.articleCategories && (
            <Link to="/delivery">
                <Grid
                    gap="1rem"
                    height="fit-content"
                >
                    <Text
                        fontSize="2rem"
                        fontWeight="light"
                    >
                        ДОСТАВКА БЛЮД
                    </Text>
                    <Grid
                        height="10px"
                        background="#000000"
                    />
                    <Image
                        src={delivery.image?.url}
                        aspectRatio="3 / 2"
                        objectFit="cover"
                    />
                    <Grid
                        templateColumns="auto 1fr"
                        gap="1.25rem"
                    >
                        <Grid
                            width="2px"
                            background="#000000"
                        />
                        <Grid
                            gap="2rem"
                        >
                            {delivery.articleCategories?.map(({
                                uid,
                                name,
                                shortDescription,
                            }) => (
                                <Grid
                                    gap="1rem"
                                    height="fit-content"
                                >
                                    <Link to={`/delivery?tab=${uid}`}>
                                        <Text
                                            fontSize="1.5rem"
                                            fontWeight="bold"
                                            textDecoration="underline"
                                        >
                                            {name}
                                        </Text>
                                    </Link>
                                    <Text
                                        fontSize="1rem"
                                        textAlign="justify"
                                    >
                                        {shortDescription}
                                    </Text>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Link>
        )}
        {culinaryStudio?.articleCategories && (
            <Link to="/culinary-studio">
                <Grid
                    gap="1rem"
                    height="fit-content"
                >
                    <Text
                        fontSize="2rem"
                        fontWeight="light"
                    >
                        КУЛИНАРНАЯ СТУДИЯ
                    </Text>
                    <Grid
                        height="10px"
                        background="#000000"
                    />
                    <Image
                        src={culinaryStudio.image?.url}
                        aspectRatio="3 / 2"
                        objectFit="cover"
                    />
                    <Grid
                        templateColumns="auto 1fr"
                        gap="1.25rem"
                    >
                        <Grid
                            width="2px"
                            background="#000000"
                        />
                        <Grid
                            gap="2rem"
                        >
                            {culinaryStudio.articleCategories?.map(({
                                uid,
                                name,
                                shortDescription,
                            }) => (
                                <Grid
                                    gap="1rem"
                                    height="fit-content"
                                >
                                    <Link to={`/culinary-studio?tab=${uid}`}>
                                        <Text
                                            fontSize="1.5rem"
                                            fontWeight="bold"
                                            textDecoration="underline"
                                        >
                                            {name}
                                        </Text>
                                    </Link>
                                    <Text
                                        fontSize="1rem"
                                        textAlign="justify"
                                    >
                                        {shortDescription}
                                    </Text>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Link>
        )}
        {outdoorBar?.articleCategories && (
            <Link to="/outdoor-bars">
                <Grid
                    gap="1rem"
                    height="fit-content"
                >
                    <Text
                        fontSize="2rem"
                        fontWeight="light"
                    >
                        ВЫЕЗДНЫЕ БАРЫ
                    </Text>
                    <Grid
                        height="10px"
                        background="#000000"
                    />
                    <Image
                        src={outdoorBar.image?.url}
                        aspectRatio="3 / 2"
                        objectFit="cover"
                    />
                    <Grid
                        templateColumns="auto 1fr"
                        gap="1.25rem"
                    >
                        <Grid
                            width="2px"
                            background="#000000"
                        />
                        <Grid
                            gap="2rem"
                        >
                            {outdoorBar.articleCategories?.map(({
                                uid,
                                name,
                                shortDescription,
                            }) => (
                                <Grid
                                    gap="1rem"
                                    height="fit-content"
                                >
                                    <Link to={`/outdoor-bars?tab=${uid}`}>
                                        <Text
                                            fontSize="1.5rem"
                                            fontWeight="bold"
                                            textDecoration="underline"
                                        >
                                            {name}
                                        </Text>
                                    </Link>
                                    <Text
                                        fontSize="1rem"
                                        textAlign="justify"
                                    >
                                        {shortDescription}
                                    </Text>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Link>
        )}
        {sweetShop?.articleCategories && (
            <Link to="/sweet-shop">
                <Grid
                    gap="1rem"
                    height="fit-content"
                >
                    <Text
                        fontSize="2rem"
                        fontWeight="light"
                    >
                        КОНДИТЕРСКАЯ
                    </Text>
                    <Grid
                        height="10px"
                        background="#000000"
                    />
                    <Image
                        src={sweetShop.image?.url}
                        aspectRatio="3 / 2"
                        objectFit="cover"
                    />
                    <Grid
                        templateColumns="auto 1fr"
                        gap="1.25rem"
                    >
                        <Grid
                            width="2px"
                            background="#000000"
                        />
                        <Grid
                            gap="2rem"
                        >
                            {sweetShop.articleCategories?.map(({
                                uid,
                                name,
                                shortDescription,
                            }) => (
                                <Grid
                                    gap="1rem"
                                    height="fit-content"
                                >
                                    <Link to={`/sweet-shop/categories/${uid}`}>
                                        <Text
                                            fontSize="1.5rem"
                                            fontWeight="bold"
                                            textDecoration="underline"
                                        >
                                            {name}
                                        </Text>
                                    </Link>
                                    <Text
                                        fontSize="1rem"
                                        textAlign="justify"
                                    >
                                        {shortDescription}
                                    </Text>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Link>
        )}
    </Grid>
);
